export default "__VITE_ASSET__ACySoTC70zVdudFou1jI1w__"